import { Form } from "react-router-dom";
import { Box, Button, Heading, Link } from "@ogt/ui";
import { useNavigate } from "react-router-dom";

export default function Fail() {
  const navigate = useNavigate();

  return (
    <div>
      <Form>
        <Box>
          <Heading focusable>Ett fel inträffade</Heading>
          <p>Något verkar ha gått fel i din ansökan. Testa gärna igen.</p>
          <p>
            Du kan också skicka in din ansökan genom att mejla{" "}
            <Link underline="always" className="inline!" href="mailto:sjukreseansokan@ostgotatrafiken.se">
              sjukreseansokan@ostgotatrafiken.se
            </Link>
          </p>
        </Box>
        <div className="flex justify-center">
          <div className="w-full text-left flex items-center">
            <Button
              iconPosition="left"
              iconSize={16}
              iconName="arrow-left"
              aria-label="Tillbaka"
              showIcon
              size="medium"
              variant="outline"
              onClick={(event) => {
                event.preventDefault();
                const backUrl = undefined;
                if (backUrl) {
                  navigate(backUrl, { replace: true });
                } else {
                  navigate(-1);
                }
              }}
            >
              Tillbaka
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
}
